import { render, staticRenderFns } from "./retunTablist.vue?vue&type=template&id=701e6508&scoped=true&"
import script from "./retunTablist.vue?vue&type=script&lang=js&"
export * from "./retunTablist.vue?vue&type=script&lang=js&"
import style0 from "./retunTablist.vue?vue&type=style&index=0&id=701e6508&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "701e6508",
  null
  
)

export default component.exports